module.exports = "/assets/data/594c7c3b11379c5c744acb1703e7f4a7-IG3.data.json";